import { useEffect, useState } from "react";

import { Box } from "@mui/material";

import useSurvey from "../../hooks/useSurvey";

const SkuStatus = ({ section, questions, sku, answers, location }) => {
  const { getSkuStatus } = useSurvey();

  const [questionStatus, setSkuStatus] = useState({ colorCode: "#ccc" });

  useEffect(() => {
    let cancelled = false;
    const compute = async () => {
      const status = await getSkuStatus(
        section,
        questions,
        sku,
        answers,
        location
      );
      if (!cancelled) setSkuStatus(status);
    };

    compute();
    return () => {
      cancelled = true;
    };
  }, [section, questions, sku, answers, location]);

  return (
    <Box
      sx={{
        width: "5px",
        height: "5px",
        backgroundColor: questionStatus.colorCode,
        margin: "1px",
        borderRadius: "50%",
      }}
    ></Box>
  );
};

export default SkuStatus;
